import { useState as n } from "react";
import { useHash as i } from "./use-hash.js";
const I = (s) => {
  const [, o] = i(), [t, c] = n(null);
  return { activeId: t ? t.id : s ?? void 0, setActiveId: (e) => {
    c({ id: e }), o(e ?? "");
  } };
};
export {
  I as useHashActiveIdState
};
